import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IComparisonButtonActiveProps {
  onClick(): void;
}

export const ComparisonButtonActive: React.FC<IComparisonButtonActiveProps> = ({ onClick }) => {
  return (
    <Button
      size="XS"
      theme="fill_secondary"
      data-mark="ComparisonControlActive"
      onClick={onClick}
      beforeIcon={<IconActionCompareAdd16 color="icon-main-default" />}
    />
  );
};
